var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLightPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.0001 14C7.65558 14 7.37493 13.7194 7.37493 13.3758V8.52452H2.53614C2.24097 8.52452 2 8.28355 2 7.98742C2 7.69129 2.24097 7.45032 2.53614 7.45032H7.37493V2.62516C7.37493 2.28065 7.65558 2 8.0001 2C8.34365 2 8.62527 2.28065 8.62527 2.62516V7.45032H13.4631C13.7592 7.45032 14.0002 7.69129 14.0002 7.98742C14.0002 8.28355 13.7592 8.52452 13.4631 8.52452H8.62527V13.3758C8.62527 13.7194 8.34365 14 8.0001 14Z",
    fill: "#291482"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightPlusIcon);
export default __webpack_public_path__ + "static/media/light-plus-icon.4e9398f8b8feb0c5f1967cdb82c3b621.svg";
export { ForwardRef as ReactComponent };